import { AxiosError } from 'axios';

export const formatErrorMessage = (error: unknown): string => {
  if (error instanceof AxiosError) {
    if (error.response?.data?.detail) {
      return error.response.data.detail;
    }
    return error.message;
  }
  return '알 수 없는 오류가 발생했습니다.';
}; 